import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import type { BlocksAprBlockComponent } from '@twisto/api-cms'

import * as styles from './apr-block.styles'

export const APRBlock = ({
  title,
  content,
  hasDivider,
}: BlocksAprBlockComponent) => (
  <div css={[styles.aprBlock, hasDivider && styles.divider]}>
    <Typography css={styles.title} variant="h3">
      {title}
    </Typography>
    <Typography css={styles.content} variant="b3">
      {content}
    </Typography>
  </div>
)
